<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space">
    <sc-dialog-title>
      {{ 'Neue Gruppe' }}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <sc-padding>
        <div style="width: 450px;" [formGroup]="profileGroup">
            <sc-string-field [grow]="true" formControlName="groupName" [required]="true" [labelDictionaryKey]="'name grouppe'"></sc-string-field>
        </div>
    </sc-padding>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' }}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled()">
          {{ 'Übernehmen' }}
        </button>
    </sc-actionbar>
</sc-flex>
